<footer class="point__footer">
  <ci-icon
    class="point__add-icon"
    name="btn-add"
    type="svg"
    scale="1.5x"
  ></ci-icon>
</footer>